import { apiGet } from './client';
import type { Environment } from '../constants';
import type { Grouping, Metric, Range } from '../dashboard/spec';

export interface MetricPoint {
  key: string;
  label: string;
  value: number;
  series?: Record<string, number>;
}

export interface MetricResult {
  metric: Metric;
  group_by: Grouping;
  range: Range | null;
  unit: 'count' | 'gbp';
  points: MetricPoint[];
}

export interface MetricQuery {
  metric: Metric;
  group_by: Grouping;
  range: Range;
}

export const getMetric = (
  environment: Environment,
  query: MetricQuery,
): Promise<{ data: MetricResult }> => {
  const params = new URLSearchParams({
    metric: query.metric,
    group_by: query.group_by,
    range: query.range,
  });
  return apiGet<{ data: MetricResult }>(environment, `/metrics?${params.toString()}`);
};
